import {resolveGoogExport} from 'dgetz/tsclj'

export function termsContent() {
  const termsContent = resolveGoogExport('ladder.agents.common.terms_content')
  return termsContent
}
